




import { Component, Vue } from 'vue-property-decorator';
import { ConfigsModuleMapper } from '@/store/modules/config';
import { ConstantsModuleMapper } from '@/store/modules/constants';
import { LHNJSSDKModuleMapper } from '@/store/modules/lhnJsSdk';

import DefaultChat from '@/components/chat/defaultChat.vue';
import RuChat from '@/components/chat/ruChat.vue';
import LHNChat from '@/components/chat/LHNChat.vue';
import RocketChat from '@/components/chat/rocketChat.vue';
import HelpDeskEddyChat from '@/components/chat/HelpDeskEddyChat.vue';

const Mappers = Vue.extend({
  computed: {
    ...ConfigsModuleMapper.mapGetters(['configIsLoaded', 'jurisdiction', 'chatButtonEnabled', 'chatButtonEnabledPeriod', 'rawChatButtonEnabledPeriod']),
    ...ConstantsModuleMapper.mapGetters(['isLoaded']),
    ...LHNJSSDKModuleMapper.mapGetters(['isAllowed']),
  },
});

@Component({
  components: {
    DefaultChat,
    RuChat,
    LHNChat,
    RocketChat,
    HelpDeskEddyChat,
  },
})
export default class ChatButtonComponent extends Mappers {
  interval: any;

  showChatButton: any = false;

  recheckChatButton() {
    this.showChatButton = this.chatButtonEnabledPeriod();
  }

  mounted() {
    if (this.rawChatButtonEnabledPeriod !== null) {
      this.interval = setInterval(this.recheckChatButton, 60000);
      this.recheckChatButton();
    } else {
      this.showChatButton = this.chatButtonEnabled;
    }
  }

  beforeDestroy() {
    clearInterval(this.interval);
  }

  get resolveChat() {
    switch (this.jurisdiction) {
      case 'RUSSIA': {
        return 'HelpDeskEddyChat';
      }
      case 'CURACAO': {
        return 'HelpDeskEddyChat';
      }
      case 'BELARUS': {
        return 'HelpDeskEddyChat';
      }
      case 'SPAIN': {
        return 'HelpDeskEddyChat';
      }
      case 'ITALY': {
        return 'LHNChat';
      }
      case 'DENMARK': {
        return 'HelpDeskEddyChat';
      }
      default: {
        return 'DefaultChat';
      }
    }
  }
}
